export enum CompanyRoleEnum {
  COMPANY_ADMINISTRATOR = 'COMPANY_ADMINISTRATOR',
  COMPANY_EDITOR = 'COMPANY_EDITOR',
  COMPANY_VIEWER = 'COMPANY_VIEWER',
}
